import axios from 'axios'
import { API_BASE_URL } from '../configs/apiClient'
import {
  LOCAL_STORAGE_REFRESH_TOKEN_KEY,
  LOCAL_STORAGE_TOKEN_ADMIN_CMS,
  LOCAL_STORAGE_TOKEN_KEY,
  USER_INFO,
} from '../configs/auth'
import authService from '../apis/authService'

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: 'application/json, text/plain, */*, application/msn.api.v1+json',
    'Content-Type': 'application/json',
  },
})

// You can add interceptors and other configurations here
axiosInstance.interceptors.request.use(async (config) => {
  const token = localStorage.getItem(LOCAL_STORAGE_TOKEN_ADMIN_CMS) ?? ''
  const token_portal = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY) ?? ''

  if (token || token_portal) {
    if (window.location.pathname.startsWith('/admin') || window.location.pathname.startsWith('/login-cms')) {
      config.headers = {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json , application/msn.api.v1+json',
      }
    } else {
      config.headers = {
        Authorization: `Bearer ${token_portal}`,
        Accept: 'application/json , application/msn.api.v1+json',
      }
    }
  } else {
    config.headers = {
      Accept: 'application/json, application/msn.api.v1+json',
    }
  }


  return config;
})

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config
    const refresh = localStorage.getItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY)
    if (error?.response?.status === 401) {
      const isCallbackRoute = window.location.pathname === '/auth/cas/callback';
      if (!isCallbackRoute) {
        localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY)
        window.location.href = '/login'
      }
      // TODO retrieve jwt token by refresh token
      // const result = await authService.refreshToken(refresh ? refresh : '')
      //
      // // TODO persist jwt token to local storage
      // if (result.data.response.accessToken) {
      //   config.headers = {
      //     authorization: `Bearer ${result.data.response.accessToken}`,
      //   }
      //   localStorage.setItem(
      //     LOCAL_STORAGE_TOKEN_ADMIN_CMS,
      //     result.data.response?.accessToken
      //   )
      //   localStorage.setItem(
      //     LOCAL_STORAGE_REFRESH_TOKEN_KEY,
      //     result.data.response?.refreshToken
      //   )
      //   // TODO retry previous request
      //   // If the error has status code 401, retry the request
      //   return axiosInstance.request(error.config)
      // }
    }

    if (error?.response?.status === 403) {
      // @ts-ignore
      const auth = JSON.parse(localStorage.getItem(USER_INFO));
      // check token expired
      const currentTime = Date.now() / 1000;
      if (auth.exp < currentTime) {
        if (window.location.pathname.startsWith('/admin') || window.location.pathname.startsWith('/login-cms')) {
          localStorage.removeItem(LOCAL_STORAGE_TOKEN_ADMIN_CMS)
        } else {
          localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY)
        }
        localStorage.removeItem(USER_INFO)
      }
    }
    throw error
  }
)
export default axiosInstance
